import HomePage from '../../components/home/HomePage'

export default function AppEN() {
  return <HomePage lang="en" />
}
